import React from 'react';
import { PropTypes } from 'prop-types';
import DoneIcon from '../../../../../assets/images/iconsV2/done.svg';
import Icon from '../../Icons/Icon';
import { capitalizeFirstLetter } from '../../../utils/api';

const Multiselect = ({
  label,
  name,
  value = [],
  options,
  setValue = () => {},
  isLabelBeside = false,
  inputHeight,
  labelMarginLeftRight = 'mx-0',
  labelMarginTopBottom = 'my-0',
  textSize,
  isRequired = false,
  asteriskWidth = 'w-2',
  headerClassName = undefined,
  spaceY = undefined,
  labelBesideLabelClasses = undefined,
  labelBesideInputClasses = undefined,
  shouldNotCapitalize = false,
  errorMessage = undefined,
  errorMessageClass = undefined,
  customErrorComponent = null,
  validationError = undefined,
  errorMessageFontClasses = undefined,
  isAlertIcon = false,
}) => {
  const onClick = (index) => {
    const updatedOptions = [...options];
    updatedOptions[index].selected = !updatedOptions[index].selected;
    const updatedValues = updatedOptions
      .filter((option) => option.selected)
      .map((option) => option.value);

    setValue(updatedOptions, updatedValues);
  };

  // render error message if any
  const renderError = () => {
    if (customErrorComponent) return customErrorComponent;

    return (
      <h4
        className={`top-full ${errorMessageClass} ${errorMessageFontClasses || 'text-vamos-red font-normal text-sm'}`}
      >
        {(isRequired && errorMessage && (!value || value.length === 0)) && (
        <div className="flex">
          {isAlertIcon && <Icon name="alert" />} {errorMessage}
        </div>
        )}
        {validationError && validationError}
      </h4>
    );
  };
  const isErrored = (isRequired
    && errorMessage
    && (!value || (Array.isArray(value) && value.length === 0)))
  || !!validationError;

  return (
    <div className={`${isLabelBeside
      ? 'flex items-start'
      : `${spaceY || 'space-y-1'} w-full`} 
    `}
    >  {label && (
    <label
      htmlFor={name}
      className={`flex cursor-default ${isLabelBeside ? 'font-bold' : ''} ${labelBesideLabelClasses || 'w-2/5'} ${headerClassName || ''}`}
    >
        {shouldNotCapitalize ? label : capitalizeFirstLetter(label)}
      {isRequired && <Icon name="required_field" className={`ml-1 mr-[2.5px] ${asteriskWidth}`} />}
    </label>
    )}

      <div className={`flex flex-col gap-y-3.5 relative ${isLabelBeside ? labelBesideInputClasses : 'w-full'}`}>
        {options.map((option, index) => (
          <label key={option.label} htmlFor={option.value} className="flex items-center cursor-pointer">
            <span className={`relative flex rounded mr-3 w-5.5 h-5.5 items-center ${inputHeight || 'h-4'}
          ${option.selected ? 'bg-vamos-black border border-vamos-black' : 'bg-vamos-true-white border border-vamos-blue-gray'}`}
            >
              <input
                id={option.value}
                name={option.value}
                type="checkbox"
                value={option.value}
                checked={!!option.selected}
                onChange={() => onClick(index)}
                className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
              />
              {option.selected && <img src={DoneIcon} alt="Done" className="w-5 h-5" />}
            </span>
            <span className={`m-0 ${labelMarginLeftRight} ${labelMarginTopBottom} ${textSize}`}>{option.label}</span>
          </label>
        ))}
        {isErrored && renderError()}
      </div>
    </div>
  );
};

Multiselect.propTypes = {
  label: PropTypes.string,
  value: PropTypes.array,
  name: PropTypes.string,
  options: PropTypes.array.isRequired,
  setValue: PropTypes.func,
  isLabelBeside: PropTypes.bool,
  inputHeight: PropTypes.string,
  labelMarginLeftRight: PropTypes.string,
  labelMarginTopBottom: PropTypes.string,
  textSize: PropTypes.string,
  headerClassName: PropTypes.string,
  spaceY: PropTypes.string,
  isRequired: PropTypes.bool,
  asteriskWidth: PropTypes.string,
  labelBesideLabelClasses: PropTypes.string,
  labelBesideInputClasses: PropTypes.string,
  shouldNotCapitalize: PropTypes.bool,
  errorMessage: PropTypes.string,
  customErrorComponent: PropTypes.node,
  validationError: PropTypes.string,
  errorMessageClass: PropTypes.string,
  isAlertIcon: PropTypes.bool,
  errorMessageFontClasses: PropTypes.string,
};

export default Multiselect;
